import React, { Fragment } from 'react';
import { createPortal } from 'react-dom';

import { controlsPortalClassName } from './PrimaryHeader';

const PrimaryHeaderControls = ({ children }) => {
  const mountNodes = document.getElementsByClassName(controlsPortalClassName);

  return (
    <Fragment>
      {
        Array.from(mountNodes).map(mountNode => (
          createPortal(children, mountNode)
        ))
      }
    </Fragment>
  );
};

export default PrimaryHeaderControls;
